import { useEffect, useRef } from "react";
import { trackAdminEvent } from "../../../../services/AdminTelemetryService";

const WINDOW_MS = 1500;
const THRESHOLD = 3;

/**
 * Detects repeated rapid clicks on the same target (UX frustration signal).
 */
export function useRageClick(): void {
	const hitsRef = useRef<Map<string, number[]>>(new Map());

	useEffect(() => {
		const onClick = (event: MouseEvent) => {
			const t = event.target as Element | null;
			if (!t) return;
			const key = `${t.tagName}|${(t as HTMLElement).className || ""}|${(t as HTMLElement).id || ""}`;
			const now = Date.now();
			const arr = hitsRef.current.get(key) || [];
			const recent = arr.filter((ts) => now - ts < WINDOW_MS);
			recent.push(now);
			hitsRef.current.set(key, recent);
			if (recent.length >= THRESHOLD) {
				void trackAdminEvent({
					eventType: "ux_signal",
					level: "warn",
					action: "rage_click",
					metadata: {
						targetTag: t.tagName,
						targetId: (t as HTMLElement).id || null,
						clickCount: recent.length,
					},
				});
				hitsRef.current.delete(key);
			}
		};
		document.addEventListener("click", onClick, true);
		return () => document.removeEventListener("click", onClick, true);
	}, []);
}
